import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { ChakraProvider } from "@chakra-ui/react";
import Login from "./pages/Login";
import Tickets from "./pages/Tickets";
import ChooseLocation from "./pages/ChooseLocation";
import ProtectedRoute from "./routes/ProtectedRoute";
import PublicRoute from "./routes/PublicRoute";
import FeatureRoute from "./routes/FeatureRoute";
import Navbar from "./navbar/Navbar";
import AuthProvider from "./context/AuthContext";
import OnlineMenu from "./pages/OnlineMenu";
import theme from "./theme";
import SharedTicketDetails from "./pages/SharedTicketDetails";
import UsersPage from "./pages/UsersPage";
import SectionsPage from "./pages/SectionsPage";
import TicketDetails from "./pages/TicketDetails";
import RecurringTickets from "./pages/RecurringTickets";
import RecurringTicketDetails from "./pages/RecurringTicketDetails";
import ChatBot from "./pages/ChatBot";
import CareersPage from "./pages/CareersPage";
import AddJobOpeningPage from './pages/AddJobOpeningPage'
import NoAccess from "./pages/NoAccess";
import ExpirationCheckPage from "./pages/ExpirationCheckPage";
import LinksPage from "./pages/LinksPage";
import PriceListsPage from "./pages/PriceListsPage";
import { FEATURE_IDS } from "./constants/featureCostants";

const App = () => {
    return (
        <AuthProvider>
            <ChakraProvider theme={theme}>
                <Router>
                    <Navbar />

                    <Routes>
                        <Route path="/login" element={<PublicRoute />}>
                            <Route path="/login" element={<Login />} />
                        </Route>

                        <Route path="/choose-location" element={<ProtectedRoute />}>
                            <Route path="/choose-location" element={<ChooseLocation />} />
                        </Route>

                        <Route path="/" element={<ProtectedRoute />}>
                            <Route path="/no-access" element={<NoAccess />} />

                            <Route element={<FeatureRoute featureIds={[FEATURE_IDS.TICKETS]} />}>
                                <Route path="/" element={<Tickets />} />
                                <Route path="/tickets" element={<Tickets />} />
                                <Route path="/details/:ticketId" element={<TicketDetails />} />
                            </Route>

                            <Route element={<FeatureRoute featureIds={[FEATURE_IDS.RECURRING_TICKETS]} />}>
                                <Route path="/recurring-tickets" element={<RecurringTickets />} />
                                <Route path="/recurring-details/:ticketId" element={<RecurringTicketDetails />} />
                            </Route>

                            <Route element={<FeatureRoute featureIds={[FEATURE_IDS.TICKETS, FEATURE_IDS.RECURRING_TICKETS]} />}>
                                <Route path="/sections" element={<SectionsPage />} />
                            </Route>

                            <Route element={<FeatureRoute featureIds={[FEATURE_IDS.USERS]} />}>
                                <Route path="/users" element={<UsersPage />} />
                            </Route>

                            <Route element={<FeatureRoute featureIds={[FEATURE_IDS.CAREERS]} />}>
                                <Route path="/careers" element={<CareersPage />} />
                                <Route path="/careers/add-job-opening" element={<AddJobOpeningPage />} />
                            </Route>

                            <Route element={<FeatureRoute featureIds={[FEATURE_IDS.ONLINE_MENU]} />}>
                                <Route path="/online-menu" element={<OnlineMenu />} />
                            </Route>

                            <Route element={<FeatureRoute featureIds={[FEATURE_IDS.CHAT]} />}>
                                <Route path="/chat" element={<ChatBot />} />
                            </Route>

                            <Route element={<FeatureRoute featureIds={[FEATURE_IDS.EXPIRATION_CHECK]} />}>
                                <Route path="/expiration-check" element={<ExpirationCheckPage />} />
                            </Route>

                            <Route element={<FeatureRoute featureIds={[FEATURE_IDS.LINKS]} />}>
                                <Route path="/links" element={<LinksPage />} />
                            </Route>

                            <Route element={<FeatureRoute featureIds={[FEATURE_IDS.PRICE_LISTS]} />}>
                                <Route path="/price-lists" element={<PriceListsPage />} />
                            </Route>
                        </Route>

                        <Route path="/tickets/shared/:ticketId/:token" element={<SharedTicketDetails />} />

                        <Route path="*" element={<Navigate to="/" />} />
                    </Routes>
                </Router>
            </ChakraProvider>
        </AuthProvider>
    );
};

export default App;